export default {
  step1: '基本信息',
  step2: '规格/价格信息',
  step3: '礼品详情',
  giftName: '礼品名称',
  giftNameRequired: '请输入礼品名称',
  giftNamePlaceholder: '请输入礼品名称',
  giftType: '礼品类型',
  giftTypeRequired: '请选择礼品类型',
  giftTypeTip: '礼品类型：实物礼品 虚拟礼品',
  physicalGift: '实物礼品',
  virtualGift: '虚拟礼品',
  giftCategory: '礼品分类',
  giftNo: '礼品编码',
  giftNoRequired: '请输入礼品编码',
  giftNoPlaceholder: '请输入礼品编码',
  giftImage: '礼品图片',
  imageRequired: '请上传礼品图片',
  giftValue: '礼品价值',
  valuePlaceholder: '请输入礼品价值',
  productSpec: '产品规格',
  singleSpec: '单规格',
  multiSpec: '多规格',
  specNamePlaceholder: '规格名',
  addSpecValue: '添加',
  addSpecGroup: '+ 添加规格',
  generateSpecs: '+ 生成规格',
  specImage: '规格图片',
  specPrice: '价格(元)',
  specStock: '库存',
  specNo: '规格编号',
  specNoPlaceholder: '请输入规格编号',
  specImageRequired: '规格图片不能为空',
  specMatrixRequired: '请先生成规格矩阵',
  stockPlaceholder: '请输入',
  editSpecName: '修改规格名称',
  select: '选择',
  giftDetail: '商品详情',
  detailPlaceholder: '请输入正文',
  detailRequired: '请输入礼品详情',
  phonePreview: '商品详情',
  applySpecChanges: '确认修改',
};
